<template>
  <b-field
    :label="label"
  >
    <b-upload
      class="file-label"
      style="flex-shrink: 0"
      multiple
      v-bind="$attrs"
      v-model="value"
      :id="forId"
      :size="size"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    >
      <span class="file-cta">
        <span class="file-label">Upload Files</span>
      </span>
    </b-upload>

    <div class="attachments" v-if="value.length !== 0">
      <span
        v-for="(file, index) in value"
        :key="index"
        class="attachments--file"
      >
        {{ file.name }}
        <icon-default
          icon="close"
          size="is-small"
          color="is-primary"
          class="attachments--file--close_icon"
          @click="removeFile(index)"
        ></icon-default>
      </span>
    </div>

    <form-validation-errors :validation-errors="validationErrors"></form-validation-errors>
  </b-field>
</template>

<script>
import FormValidationErrors from "./FormValidationErrors";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldAttachment",
  components: {FormValidationErrors},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
      default: "Attachments"
    },
    validationErrors: {
      type: [
        String,
        Array,
        Object,
        undefined
      ],
    },
    helpText: {
      type: String
    },
    size: {
      type: String,
      default: "is-small"
    },
    debounce: {
      type: Function,
      required: false
    },
    debounceTimeout: {
      type: Number,
      required: false,
      default: 500
    },
  },
  data() {
    return {
      forId: this.inputId ? this.inputId : this.$utils.generateClientId(),
      debounceRef: undefined,
    };
  },
  watch: {
    /**
     * watch files coz I need to catch the removeFile method
     * @input doesn't update the files model when removing a file
     */
    value(val) {
      this.handleInput(val);
    }
  },
  methods: {
    removeFile(index) {
      this.value.splice(index, 1);
    },
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.emitGlobalFieldChangeEvent();

      if (this.debounce) {
        this.debounceRef = this.$utils.debounce(this.debounce, this.debounceRef, this.debounceTimeout);
      }
    },
  }
};
</script>

<style lang="scss" scoped>

// This is so the files are vertically centered
::v-deep .field.has-addons {
  align-items: center;
}

.attachments {
  display: flex;
  flex-wrap: wrap;

  &--file {
    margin: 4px 0 4px 1rem;

    &--close_icon {
      vertical-align: middle;
      cursor: pointer;
    }
  }
}
</style>
